module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"detected_issues":"Detected you may have the following issues:","more":"More>>","ask_ai_editor":"Ask AI Chief Editor"},"zh":{"detected_issues":"检测到您可能遇到以下问题：","more":"更多>>","ask_ai_editor":"问问AI总编"}}')
  delete Component.options._Ctor
}
